import { Component } from '@angular/core';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './search.hooks';

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss'],
	standalone: false,
})
export class TeranetStepperSearchComponent {
	testHooks = TestHooks;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	public showFooter = false;

	constructor(private matterDispatch: MatterDispatch) {}

	next = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.SYNC,
		);
	};

	onSearchCompleted(event: boolean) {
		this.showFooter = event;
	}
}
